// extracted by mini-css-extract-plugin
export var wrapper = "education-module--wrapper--2q4-Q";
export var outerWrapper = "education-module--outerWrapper--1U324";